module.exports = __webpack_public_path__ + "static/img/ic_abx_logo.3b2a7cfd.jpg";